/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Rummet for venskaber",
      "Find nye venner med Bumble For Friends-appen | Bumble",
      "Download på App Store",
      "Hent den på Google Play",
      "Et dedikeret sted til at få nye venner",
      "Find personer nær dig, som leder efter ægte forbindelser.",
      "Find venner, uanset hvor du er i livet",
      "Ny i byen? Brug for en frisk start? Dit nye crew venter på dig!",
      "Et trygt sted for alle",
      "Velkommen til et venligt sted på internettet, hvor du kan være dig selv.",
      "Download appen",
      "Mød personer med samme interesser som dig IRL!",
      "Lær en ny gruppe personer at kende med Plans på Bumble For Friends",
      "Du er blevet inviteret til Plans",
      "Plans er en ny funktion på Bumble For Friends, hvor du kan skabe og tilmelde dig gruppeevents med nye venner nær dig.",
      "Administrer cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dage",
                  "dages"
            ],
            "singular": [
                  "dag",
                  "dags"
            ]
      },
      "hour": {
            "plural": [
                  "timer",
                  "timers"
            ],
            "singular": [
                  "time",
                  "times"
            ]
      },
      "minute": {
            "plural": [
                  "minutter",
                  "minutters"
            ],
            "singular": [
                  "minut",
                  "minuts"
            ]
      },
      "month": {
            "plural": [
                  "måneder",
                  "måneders"
            ],
            "singular": [
                  "måned",
                  "måneds"
            ]
      },
      "second": {
            "plural": [
                  "sekunder",
                  "sekunders"
            ],
            "singular": [
                  "sekund",
                  "sekunds"
            ]
      },
      "year": {
            "plural": [
                  "år",
                  "årenes"
            ],
            "singular": [
                  "år",
                  "årets"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
